<template>
  <div>
    <div class="info">
      Criteria must meet at least one of the following filter groups (max 5):
    </div>
    <FiltersGroup
      v-for="(group, index) in filtersGroupsLocalValue"
      :key="'filter-group-'+index"
      :groupName="'filter-group-'+index"
      :filters="group"
      :optionsList="optionsList"
      :dateRange="dateRange"
      :brandIds="brandIds"
      class="filters-group"
      @remove="removeGroup(index)"
      @updateGroup="updateGroup(index, $event)">
    </FiltersGroup>
    <div
      v-if="canAddGroup"
      class="or-option"
    >
      <TertiaryBadge
        @click="addGroup"
      >
        OR
        <template v-slot:icon>
          <PlusIcon size="small" />
        </template>
      </TertiaryBadge>
    </div>
  </div>
</template>
<script>
import {
  TertiaryBadge,
  PlusIcon,
} from '@mikmak/components';
import FiltersGroup from './FiltersGroup';
import { cloneDeep } from 'lodash';

export default {
  props: {
    availableShopperIntelligenceFilters: {
      type: Array,
      required: true,
    },
    availableInsightsFilters: {
      type: Array,
      required: true,
    },
    selectedFiltersGroups: {
      type: Array,
    },
    dateRange: {
      type: Object,
    },
    brandIds: {
      type: Array,
    },
  },
  data() {
    return {
      filtersGroupsLocalValue: cloneDeep(this.selectedFiltersGroups || []),
      groupsLimit: 5,
    };
  },
  methods: {
    addGroup() {
      const emptyFilter = {
        key: '',
        operator: '',
        value: [],
      };

      this.filtersGroupsLocalValue.push([emptyFilter]);
      this.$emit('updateAdvancedFilters', this.filtersGroupsLocalValue);
    },
    removeGroup(index) {
      this.filtersGroupsLocalValue.splice(index, 1);
      if (this.filtersGroupsLocalValue.length === 0) this.addGroup();
      this.$emit('updateAdvancedFilters', this.filtersGroupsLocalValue);
    },
    updateGroup(index, group) {
      this.filtersGroupsLocalValue.splice(index, 1, group);
      this.$emit('updateAdvancedFilters', this.filtersGroupsLocalValue);
    },
  },
  computed: {
    canAddGroup() {
      return this.filtersGroupsLocalValue.length < this.groupsLimit;
    },
    optionsList() {
      return this.availableShopperIntelligenceFilters
        .concat(this.availableInsightsFilters);
    },
  },
  components: {
    TertiaryBadge,
    PlusIcon,
    FiltersGroup,
  },
  created() {
    if (this.filtersGroupsLocalValue.length === 0) this.addGroup();
  },
  watch: {
    selectedFiltersGroups() {
      this.filtersGroupsLocalValue = cloneDeep(this.selectedFiltersGroups || []);
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  padding-bottom: 24px;
}
.or-option {
  margin-left: 16px;
}
::v-deep {
& .badge-wrapper {
    padding: 0;
    margin: 0;
  }
}
</style>
